import type { GridColDef } from "@mui/x-data-grid-premium";

export const getDateQuickFilter =
  (formatDate: (date: string) => string): GridColDef["getApplyQuickFilterFn"] =>
  searchValue => {
    const query = String(searchValue).toLowerCase();
    return (_, row, column) => {
      const date = row[column.field];
      return !!date && formatDate(date).toLowerCase().includes(query);
    };
  };
